import { getFormattedCurrency } from './getFormattedCurrency';
import { defaultDoubleCurrencyDelimiter } from '../constants';

/**
 * Additional options for formatting the value.
 *
 * @property {string} doubleCurrencyDelimiter the custom delimiter to be used instead of default for double currency
 */

export function formatCurrency(value, culture, options) {
  var _options$doubleCurren;
  var _getFormattedCurrency = getFormattedCurrency(value, culture),
    currencies = _getFormattedCurrency.currencies;
  return currencies.filter(Boolean).join((_options$doubleCurren = options === null || options === void 0 ? void 0 : options.doubleCurrencyDelimiter) !== null && _options$doubleCurren !== void 0 ? _options$doubleCurren : defaultDoubleCurrencyDelimiter);
}